/* Shared link styles for content page components.
 *
 * Base properties (text-underline-offset, text-decoration-thickness,
 * transition, focus-visible) come from the .content a {} rule in
 * HtmlArticle.module.css — NOT duplicated here. */

/* Navigation links: segment links, topic links, cross-references.
 * Teal color with solid underline. */
.navLink {
    color: var(--article-link);
    text-decoration: underline;
    text-decoration-color: color-mix(in srgb, var(--article-link) 35%, transparent);

    &:hover {
        color: var(--article-link-hover);
        text-decoration-color: var(--article-link-hover);
    }
}

/* Panel-trigger links: auto-links, definitions, footnotes.
 * Inherit text color with dotted underline. Opens a drawer/panel. */
.panelLink {
    color: inherit;
    cursor: pointer;
    text-decoration: underline dotted;

    &:hover {
        color: var(--mantine-color-gneis-9);
    }
}
